import { UIKIT_SCHEME_MAP, UIKIT_SCHEME_IMPORT_MAP } from '@/common/constants/themes.constants';

export const loadUikitColorScheme = async (schemeName) => {
  const uikitScheme = await (
      UIKIT_SCHEME_IMPORT_MAP[schemeName]
      || UIKIT_SCHEME_IMPORT_MAP[UIKIT_SCHEME_MAP.DEFAULT])();

  return uikitScheme.default;
};

export default loadUikitColorScheme;
